export default __webpack_public_path__ + "9dbdb3dc01594c01b1efb6e097acd569.jpg";